/**
 * Determines if the given aspect ratio represents a portrait orientation
 * @param aspectRatio - String in format "width/height" (e.g., "16/10", "9/16")
 * @returns true if portrait, false if landscape
 */
export const isPortraitOrientation = (aspectRatio: string): boolean => {
    const [width, height] = aspectRatio.split('/').map(Number);
    return height > width;
  };